//src/components/StocksSidebar.jsx
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const SidebarContainer = styled.div`
  width: 220px;
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  overflow-y: auto;
  border-right: 2px solid #ccc;
  background: #f9f9f9;
  padding: 1rem;
  z-index: 1000;

  @media only screen and (max-width: 768px) {
    top: 100px;
    height: calc(100vh - 100px);
    width: 75%;
    max-width: 280px;
    transform: translateX(${(props) => (props.open ? "0" : "-100%")});
    transition: transform 0.3s ease;
    z-index: 10000;
    box-shadow: ${(props) =>
      props.open ? "4px 0 10px rgba(0,0,0,0.2)" : "none"};
  }
`;

const OvalButton = styled(Link)`
  display: block;
  margin-bottom: 12px;
  padding: 10px 16px;
  border-radius: 30px;
  background: #e0e0e0;
  text-align: center;
  text-decoration: none;
  color: #333;
  border: 1px solid #bbb;
  transition: 0.2s;

  &:hover {
    background: #d4d4d4;
    transform: translateX(4px);
  }
`;

export default function StocksSidebar({
  openDividends,
  openPERatio,
  openHeatmap,
  open,
  onClose,
}) {
  const handleLinkClick = () => {
    if (onClose) onClose();
  };

  return (
    <SidebarContainer open={open}>
      {/* Phase 2B — "Stock Markets" sends the user to the all-markets
          landing page, which defaults to Dow Jones. From there they can
          switch markets via the dropdown (which navigates to its own URL). */}
      <OvalButton to="/stocks/all_stock_markets" onClick={handleLinkClick}>
        Stock Markets
      </OvalButton>
      <OvalButton to="/stocks/crypto" onClick={handleLinkClick}>
        CryptoCurrencies
      </OvalButton>
      <OvalButton to="/stocks/dinar" onClick={handleLinkClick}>
        📈 Currencies
      </OvalButton>
      <OvalButton to="/stocks/metals" onClick={handleLinkClick}>
        Gold And Metals
      </OvalButton>
      <OvalButton to="/stocks/etf" onClick={handleLinkClick}>
        ETF
      </OvalButton>

      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <OvalButton
          as="button"
          type="button"
          onClick={() => {
            openDividends();
            if (onClose) onClose();
          }}
          style={{
            background: "#d9f2ff",
            cursor: "pointer",
          }}
        >
          Dividends
        </OvalButton>

        <OvalButton
          as="button"
          type="button"
          onClick={() => {
            openPERatio();
            if (onClose) onClose();
          }}
          style={{
            background: "#ffe6cc",
            cursor: "pointer",
          }}
        >
          P/E Ratio
        </OvalButton>
      </div>

      <OvalButton
        as="button"
        type="button"
        onClick={() => {
          openHeatmap();
          if (onClose) onClose();
        }}
        style={{
          background: "#d4ffd4",
          cursor: "pointer",
        }}
      >
        Heat Map
      </OvalButton>
    </SidebarContainer>
  );
}
